export default __webpack_public_path__ + "static/assets/a105726b1ac67b7fe2ac15dcc2a9b809.png";